import { render, staticRenderFns } from "./TextOutdent.vue?vue&type=template&id=f9d3422c"
import script from "./TextOutdent.vue?vue&type=script&lang=js"
export * from "./TextOutdent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports